import { ChakraProvider } from "@chakra-ui/react";
import theme from "@/app/configs/theme";
import { ThemeProvider } from "@/app/providers/theme-provider";
import { TranslateProvider } from "@/app/providers/translate-provider";
import { AuthProvider } from "./auth-provider";

export function RootProvider(props: React.PropsWithChildren) {
  return (
    <AuthProvider>
      <TranslateProvider>
        <ChakraProvider theme={theme} toastOptions={{ defaultOptions: { position: "top-right" } }}>
          <ThemeProvider>{props.children}</ThemeProvider>
        </ChakraProvider>
      </TranslateProvider>
    </AuthProvider>
  );
}
